import React from 'react';
import { View, StyleSheet, Text, Image } from 'react-native';

import AppButton from '../components/AppButton';
import Colors from '../utils/colors';
import useStatusBar from '../hooks/useStatusBar';
import { AnonymousLogin } from '../components/Firebase/firebase';

export default function WelcomeScreen({ navigation }) {
  useStatusBar('light-content');

  async function handleOnLogin() {
    try {
      await AnonymousLogin();
    } catch (error) {
      console.log(error.message);
    }
  }
  return (
    <View style={styles.container}>
      <View style={styles.logoContainer}>
        <Image source={require('../assets/1024.png')} style={styles.logo} />
        <Text style={styles.subtitle}>Bienvenido</Text>
      </View>
      <View style={styles.buttonContainer}>
        <AppButton title="Acceder" onPress={handleOnLogin} />
        <AppButton
          title="Necesito ayuda"
          color="secondary"
          onPress={() => navigation.navigate('Ayuda')}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'flex-end',
    alignItems: 'center',
    backgroundColor: '#111827'
  },
  logoContainer: {
    position: 'absolute',
    top: 60,
    alignItems: 'center'
  },
  logo: {
    width: 155,
    height: 155,
    borderRadius: 12
  },
  subtitle: {
    fontSize: 44,
    alignSelf: 'center',
    fontWeight: '600',
    paddingVertical: 50,
    color: 'white'
  },
  buttonContainer: {
    padding: 20,
    paddingBottom: 60,
    width: '100%'
  }
});
